'use strict';

var $ = require('../internals/export');

var anObject = require('../internals/an-object');

var getMapIterator = require('../internals/get-map-iterator');

var sameValueZero = require('../internals/same-value-zero');

var iterate = require('../internals/iterate'); // `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods


$({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  includes: function includes(searchElement) {
    return iterate(getMapIterator(anObject(this)), function (key, value, stop) {
      if (sameValueZero(value, searchElement)) return stop();
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).stopped;
  }
});